import { ChangeDetectionStrategy, Component, HostBinding, computed, input } from '@angular/core';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons/index.js';
import { IconColor, IconSize, IconType, iconTransformation } from './icon.models.js';

@Component({
	selector: 'lib-icon',
	templateUrl: './icon.component.html',
	styleUrls: ['./icon.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class IconComponent {
	@HostBinding('style') style = 'display: inline-block';

	public readonly type = input.required<IconType>();
	public readonly size = input<IconSize>('default');
	public readonly color = input<IconColor>('default');

	public readonly transformedIcon = computed<IconDefinition>(() => {
		return iconTransformation[this.type()];
	});

	public readonly transformedSizeProp = computed<SizeProp>(() => {
		const size = this.size();

		if (size === 'small') {
			return 'sm';
		}

		if (size === 'large') {
			return 'lg';
		}

		if (size === 'extraLarge') {
			return 'xl';
		}

		if (size === 'huge') {
			return '2xl';
		}

		return '1x';
	});

	public readonly wrapperClass = computed<string>(() => {
		return `ui-icon`;
	});

	public readonly iconClass = computed<string>(() => {
		return `${this.getColorClass()}`;
	});

	private getColorClass(): string {
		const color = this.color();

		if (!color) {
			return 'color-default';
		}

		return `color-${color}`;
	}
}
